import React, { useEffect, useImperativeHandle } from 'react';
import { useSetState } from 'ahooks';
import { Box, Dialog, Field, Form, Input, Message } from '@fpxfd/next';
import $i18n from 'panda-i18n';
import { breakLine } from '@/utils';
import { addOrUpdateRelativeNo } from './index.services';

interface Props {
  consignmentNo: string;
  relativeData: object;
  uptRef?: any;
  callBack: Function;
}
const AssociatedOrderCom = ({ consignmentNo, relativeData, uptRef, callBack }: Props) => {
  const field = Field.useField([]);
  const [states, setStates] = useSetState({
    visible: false,
  });
  useImperativeHandle(uptRef, () => ({
    changeApVisible: (newVal) => {
      setStates({ visible: newVal });
    },
  }));
  const handleCloseDialog = () => {
    setStates({ visible: false });
  };

  const handleOk = () => {
    field.validate((errors, info: any) => {
      if (errors) {
        return;
      }
      const relativeNosIc = breakLine(info.relativeNosIc) || [];
      const relativeNosOc = breakLine(info.relativeNosOc) || [];
      const params: any = {
        consignmentNo,
        relativeNoInfos: [
          { relativeBusinessNos: relativeNosIc, relativeBusinessType: 'IC' },
          { relativeBusinessNos: relativeNosOc, relativeBusinessType: 'OC' },
        ],
      };
      // params['relativeNoInfos'].push({ relativeBusinessNos: relativeNosIc, relativeBusinessType: 'IC' });
      // params['relativeNoInfos'].push({ relativeBusinessNos: relativeNosOc, relativeBusinessType: 'OC' });
      addOrUpdateRelativeNo(params).then((res) => {
        Message.success($i18n.get({ id: 'XGCG.Modified.four_px', dm: '修改成功' }));
        setStates({ visible: false });
        callBack && callBack();
      });
    });
  };

  useEffect(() => {
    relativeData?.relativeNoInfos?.map((item) => {
      if (item.relativeBusinessType === 'IC') {
        field.setValue('relativeNosIc', item.relativeBusinessNos?.join('\n'));
      }
      if (item.relativeBusinessType === 'OC') {
        field.setValue('relativeNosOc', item.relativeBusinessNos?.join('\n'));
      }
    });
  }, [relativeData, states.visible]);
  return (
    <Dialog
      title={$i18n.get({ id: 'AssociatedDocumentNumberChange', dm: '关联单号变更' })}
      visible={states.visible}
      style={{ width: 600 }}
      onCancel={() => {
        handleCloseDialog();
      }}
      onClose={() => {
        handleCloseDialog();
      }}
      onOk={() => {
        handleOk();
      }}
    >
      <div style={{ padding: '0 10px' }}>
        <Form field={field} fullWidth>
          <div>{$i18n.get({ id: 'AutoassociatedDocumentNumber', dm: '自动关联单号' })}</div>
          <Form.Item>
            <Input value={relativeData?.customerRelativeNos?.join(',')} trim disabled />
          </Form.Item>
          <div>{$i18n.get({ id: 'ManuallyLinkOrders', dm: '手动关联订单' })}</div>
          <Box direction="row" spacing={[10]}>
            <Box flex={1}>
              <Form.Item label={$i18n.get({ id: 'InboundOrder.four_px', dm: '入库订单' })}>
                <Input.TextArea
                  name="relativeNosIc"
                  style={{ width: '100%' }}
                  placeholder={$i18n.get({
                    id: 'ZCDTSJ，YHHFJHFG.SeparateMultipleDataEntriesWithLine_1189086258.four_px',
                    dm: '支持多条数据，用换行符进行分隔',
                  })}
                />
              </Form.Item>
            </Box>
            <Box flex={1}>
              <Form.Item label={$i18n.get({ id: 'CKDD.OutboundOrder.four_px', dm: '出库订单' })}>
                <Input.TextArea
                  name="relativeNosOc"
                  style={{ width: '100%' }}
                  placeholder={$i18n.get({
                    id: 'ZCDTSJ，YHHFJHFG.SeparateMultipleDataEntriesWithLine_1189086258.four_px',
                    dm: '支持多条数据，用换行符进行分隔',
                  })}
                />
              </Form.Item>
            </Box>
          </Box>
        </Form>
      </div>
    </Dialog>
  );
};

export default AssociatedOrderCom;
